<div class="info">
  <ion-label class="title"> Ofertas </ion-label>
  <ion-label>Fique por dentro</ion-label>

  <swiper-container slides-per-view="4.5">
    <swiper-slide
      *ngFor="let item of listInfoOffer; let i = index"
      (click)="touchShowModal(item)"
    >
      <ion-img  [src]="modelLocator.configUso._media + 'thumbs/' + item.thumb_oferta"></ion-img>
    </swiper-slide>
  </swiper-container>
  <div class="divImage"></div>

  <ion-modal [isOpen]="isOpen" (click)="isOpen = false"
  cssClass="transparent-modal">
    <ng-template>
      <ion-content class="transparent-modal">
        <div class="detail">
          <ion-img [src]="showInfo.imagem_oferta"></ion-img>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>

  <!-- <ion-popover #popover [isOpen]="isOpen" (didDismiss)="isOpen = false" class="custom-popover">

  </ion-popover> -->
</div>

<br />
